import React, { Component } from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {
  toggleLightbox,
  setLightboxImage,
  populateLightboxGallery,
  saveLightboxGallery,
} from '../../actions/lightbox';

class Thumbnail extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    const { id, galleryId, src, fullSrc, alt, populateLightboxGallery, saveLightboxGallery, isFinalImage, savedGalleries } = this.props;
    if(!savedGalleries.find((savedGallery) => savedGallery === galleryId)) {
      populateLightboxGallery(id, galleryId, fullSrc, src, alt);
      if(isFinalImage) {
        saveLightboxGallery(galleryId);
      }
    }
  }

  handleClick() {
    const { galleryId, fullSrc, alt, id } = this.props;
    this.props.setLightboxImage(galleryId, id, fullSrc, alt);
    this.props.toggleLightbox(true);
  }

  render() {
    const { src, alt } = this.props;
    return (
      <img
        className="fe-lightbox-thumb"
        onClick={this.handleClick}
        src={src}
        alt={alt}
      />
    );
  }
}

const mapStateToProps = ({ lightboxState }) => ({
  savedGalleries: lightboxState.savedGalleries,
});

const mapDispatchToProps = {
  toggleLightbox,
  setLightboxImage,
  populateLightboxGallery,
  saveLightboxGallery,
};

export default connect(mapStateToProps, mapDispatchToProps)(Thumbnail);

Thumbnail.propTypes = {
  id: PropTypes.number.isRequired,
  galleryId: PropTypes.string,
  fullSrc: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  toggleLightbox: PropTypes.func.isRequired,
  setLightboxImage: PropTypes.func.isRequired,
  populateLightboxGallery: PropTypes.func.isRequired,
  isFinalImage: PropTypes.bool.isRequired,
  saveLightboxGallery: PropTypes.func.isRequired,
  savedGalleries: PropTypes.array.isRequired,
};

Thumbnail.defaultProps = {
  alt: '',
  isFinalImage: false,
};

